  export const environment = {
    production: false,
    serverUrl: 'https://ngyii3o55l.execute-api.us-east-2.amazonaws.com/dev',
    tokenEndpoint: 'https://auth.cutpoint.redthreaddemo.com/oauth2/token',
    redirectUrl: 'https://cutpoint.redthreaddemo.com',
    managedLoginUrl: 'https://auth.cutpoint.redthreaddemo.com/login',
    bucket: 'cutpoint-oidc-upload',
    userPool: {
      UserPoolId: 'us-east-2_FvUeR0WNG',
      ClientId: 'snvkbl550pkifsn756bl83lpd',
      region: 'us-east-2'
    },
    identityPoolId: 'us-east-2:6e1e2771-d621-41d1-8f2e-e769dcec19d6',
    buckets: {
      'us-east-2': 'cutpoint-oidc-upload'
    },
    defaultRegion: 'us-east-2',
    cognito: {
      identityPoolId:'us-east-2:6e1e2771-d621-41d1-8f2e-e769dcec19d6', //REQUIRED - Amazon Cognito Identity Pool ID
      region: 'us-east-2', // REQUIRED - Amazon Cognito Region
      userPoolId: 'us-east-2_FvUeR0WNG', //OPTIONAL - Amazon Cognito User Pool ID
      userPoolWebClientId: 'snvkbl550pkifsn756bl83lpd', //OPTIONAL - Amazon Cognito Web Client ID
    },
    Storage: {
      AWSS3: {
        bucket: 'cutpoint-oidc-upload', //REQUIRED -  Amazon S3 bucket
        region: 'us-east-2', //OPTIONAL -  Amazon service region
      }
    }
  };

const awsconfig = {
  'aws_project_region': 'us-east-2',
  'aws_cognito_region': 'us-east-2',
  'aws_user_pools_id': 'us-east-2_FvUeR0WNG',
  'aws_user_pools_web_client_id': 'snvkbl550pkifsn756bl83lpd',
  'aws_cognito_mfa_configuration': 'OPTIONAL',

};
export default awsconfig;